import {settings, TERM_CLASSIFICATOR} from "../app";
import {initMoneyInput, initPlaceholders} from "../helpers/form-helpers";
import Cookies from 'js-cookie';
import {numberFormat} from "../helpers/others";

export function initLanding() {
    const $landingForm = $('#landing_form');
    const $loansList = $('#loans_list');
    const $errorMessage = $('#error_message');

    if (!$landingForm.length && !$loansList.length) {
        return
    }

    const MODE = 'prod';
    let AJAX_URL = ''

    switch (MODE) {
        case 'dev':
            AJAX_URL = ''
            break;

        case 'prod':
            AJAX_URL = window.location.origin
            break
    }

    const LANDING_COUNTRY = $landingForm.attr('data-country') || 'Turkey';
    const TYPE = $landingForm.attr('data-type') || 'MFO';

    if (!Object.keys(settings).includes(LANDING_COUNTRY)) {
        showErrorMessage();

        return;
    }

    const CURRENT_COUNTRY = settings[LANDING_COUNTRY];
    const COUNTRY_CODE = CURRENT_COUNTRY['country_code'];
    const CURRENCY_CODE = CURRENT_COUNTRY['currency_code'];
    const CURRENCY_SYMBOL = CURRENT_COUNTRY['currency_symbol'];
    const ITEM_BUTTON_TEXT = CURRENT_COUNTRY['item_button_text'];
    const ITEM_TERM_TEXT = CURRENT_COUNTRY['item_term_text'];
    const ITEM_SUM_TEXT = CURRENT_COUNTRY['item_sum_text'];
    const ITEM_STAKE_TEXT = CURRENT_COUNTRY['item_stake_text'];
    const ITEM_FROM_TEXT = CURRENT_COUNTRY['item_from_text'];

    const $sumInput = $landingForm.find('#sum');

    const SUM_MIN = +$landingForm.attr('data-sum_min') || 1000;
    const SUM_MAX = +$landingForm.attr('data-sum_max') || 100000;
    const SUM_STEP = +$landingForm.attr('data-sum_step') || 1000;

    const SOURCE_COOKIE = Cookies.get('source');

    let CLIENT_ID = ''

    $sumInput.on('change', (e) => {
        const $this = $(e.currentTarget);
        const sumValue = $this.val().trim();

        if (sumValue !== '') {
            $this.val(setCorrectSumToInput(sumValue));
        }

        return false
    })

    $landingForm.on('submit', () => {
        if ($landingForm.hasClass('load')) { return false }

        getProducts();
        return false;
    })


    init();

    function init() {
        $sumInput.attr('data-currency', ' ' + CURRENCY_SYMBOL)

        initMoneyInput();
        initPlaceholders();

        getProducts();
    }

    function getProducts() {
        CLIENT_ID = Cookies.get('_ga');

        if (CLIENT_ID) {
            CLIENT_ID = CLIENT_ID.split('.').slice(-2).join('.')
        } else {
            try {
                CLIENT_ID = ga(function (tracker){
                    CLIENT_ID = tracker.get('clientId')
                })
            } catch (e) {
                console.warn('no ga id')
            }
        }

        const data = {
            productType: TYPE,
            country: COUNTRY_CODE,
            currencyCode: CURRENCY_CODE,
            summ: +$sumInput.val().trim() || '',
            sessionParameters: {
                gaClientId: CLIENT_ID
            }
        }

        $landingForm.addClass('load')
        $loansList.addClass('load')

        $.ajax({
            url: `${AJAX_URL}/api/getProducts.php`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (data) {
                if (data && data?.productInfo) {
                    $loansList.html(getListTemplate(data.productInfo))

                    removeLoader()
                } else {
                    showErrorMessage()
                }
            },
            error: function () {
                if (MODE === 'dev') {
                    const data = getMockupData();

                    if (data && data?.productInfo) {
                        $loansList.html(getListTemplate(data?.productInfo))

                        removeLoader();
                    } else {
                        showErrorMessage()
                    }
                } else {
                    showErrorMessage()
                }
            },
            timeout: 30000
        })
    }

    function getListTemplate(list) {
        if (!list && !list.length) {
            return ''
        }
        let result = ''

        for (let listElement of list) {
            result += getListItemTemplate(listElement)
        }

        if (result.length) {
            result = ` <div class="flex-grid wrap justify-content-start">${result}</div>`
        }

        return result
    }

    function getListItemTemplate(item) {
        if (!Object.keys(item).length) return '';

        const name = item?.partnerName || '';
        const rating = item?.rating || 0;
        const logo = item?.logoLink || '';
        const partnerURL = item?.partnerURL || '';
        const minStake = item?.minRate || 0;
        const maxStake = item?.maxRate || 0;
        const productName = item?.productName || '';
        const summ = item?.summ || 0;
        const regularPayment = item?.regularPayment || 0;
        const term = item?.term || 1;
        const termUnit = item.termUnit || '';
        const amountMin = item.amountMin || '';
        const amountMax = item.amountMax || '';

        let partnerUrlWithParams = '';

        if (!name && !partnerURL) return '';

        if (partnerURL) {
            let prefix = '?';
            let source = '';
            let aff_unique2 = '';

            if (partnerURL.includes('?')) {
                prefix = '&';
            }

            if (SOURCE_COOKIE) {
                source = `${prefix}source=${SOURCE_COOKIE}`
            }

            if (CLIENT_ID) {
                aff_unique2 = `${partnerUrlWithParams}&aff_unique2=${CLIENT_ID}`
            }

            partnerUrlWithParams = `${partnerURL}${source}${aff_unique2}`
        }

        return ` <div class="col w-25-desktop w-50-tablet w-50-mobile">
                    <div class="item">
                       <div class="item-head">
                           <div class="logo" style="background-image: url(${logo})"></div>
                           <div class="info">
                               <div class="wrap">
                                   <div class="name">${name}</div>
                                   <div class="rating">
                                       <div class="icon"></div>
                                       <div class="text">${rating}</div>
                                   </div>
                               </div>
                               <div class="description">${productName}</div>
                           </div>
                       </div>
                        <div class="item-info">
                            <div class="it for-summ">
                                <div class="name">${ITEM_SUM_TEXT}</div>
                                <div class="value">${numberFormat(amountMin)} - ${numberFormat(amountMax)} ${CURRENCY_SYMBOL}</div>
                            </div>

                            <div class="it">
                                <div class="name">${ITEM_TERM_TEXT}</div>
                                <div class="value">${term} ${TERM_CLASSIFICATOR[termUnit][LANDING_COUNTRY] || ''}</div>
                            </div>

                            <div class="it">
                                <div class="name">${ITEM_STAKE_TEXT}</div>
                                <div class="value">${ITEM_FROM_TEXT} ${minStake}%</div>
                            </div>
                        </div>
                        <a href="${partnerUrlWithParams}" class="button theme-secondary" target="_blank">${ITEM_BUTTON_TEXT}</a>
                    </div>
                </div>`
    }

    function removeLoader() {
        setTimeout(() => {
            $loansList.removeClass('load')
            $landingForm.removeClass('load')
        }, 500)
    }

    function showErrorMessage() {
        $landingForm.removeClass('load')
        $loansList.addClass('hide');
        $errorMessage.removeClass('hide')
    }

    function setCorrectSumToInput(sum) {
        let val = +sum;
        const ost = val % SUM_STEP;

        if (ost >= SUM_STEP) {
            val = Math.ceil(val / SUM_STEP) * SUM_STEP;

        } else if (ost < SUM_STEP && ost > 0) {
            val = Math.ceil(val / SUM_STEP) * SUM_STEP;
        }

        if (val > SUM_MAX) {
            val = SUM_MAX;
        } else if (val < SUM_MIN) {
            val =SUM_MIN;
        }

        return val;
    }

    function getMockupData() {
        return {
            productInfo: [
                {
                    partnerName: 'MoneyMan',
                    rating: 5.4,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 4,
                },
                {
                    partnerName: 'MoneyMan 2',
                    rating: 5.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                },
                {
                    partnerName: 'MoneyMan 3',
                    rating: 3.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                },
                {
                    partnerName: 'MoneyMan 4',
                    rating: 3.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                },
                {
                    partnerName: 'MoneyMan 5',
                    rating: 3.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                },
                {
                    partnerName: 'MoneyMan 6',
                    rating: 3.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                },
                {
                    partnerName: 'MoneyMan 7',
                    rating: 3.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                },
                {
                    partnerName: 'MoneyMan 8',
                    rating: 3.0,
                    logoLink: './img/moneyman.svg',
                    partnerURL: '#url',
                    minStake: 1,
                    productName: 'Заем для новых клиентов',
                    term: 2,
                    termUnit: 6,
                }
            ]
        }
    }
}
